import { useEffect, useState } from "react";
import Button from "../components/common/Button";
import { useTranslation } from "react-i18next";
import { getBooking, searchBooking } from "../api";
import { AxiosError } from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { STORAGE_KEY } from "../constants";

const BookingPage = () => {
  const [reservationNo, setReservationNo] = useState("");
  const [name, setName] = useState("");

  const navigate = useNavigate();
  const { hotelId } = useParams();
  const { t } = useTranslation();

  const isDisabled = !reservationNo || !name;

  const handleSearch = async () => {
    const hotel_id = encodeURIComponent(hotelId || "");

    try {
      const { data } = await searchBooking(hotel_id, reservationNo, name);
      if (data.code === "0000") {
        localStorage.setItem(STORAGE_KEY.SKIP_KAKAO, "true");
        window.location.replace(data.data.smartCheckInUrl);
        return;
      }
      alert(data.message);
    } catch (error) {
      if (error instanceof AxiosError) {
        alert(error.response?.data.message);
      }
    }
  };

  const fetchBooking = async () => {
    try {
      // 예약 상태가 오류이면 catch로 가기 위해 getBooking() 사용
      await getBooking();

      const params = localStorage.getItem(STORAGE_KEY.PARAMS);
      if (params) {
        const { hotelCode, reservationNo } = JSON.parse(params);
        navigate(`/?h=${hotelCode}&r=${reservationNo}`, { replace: true });
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        alert(error.response?.data.message);
        localStorage.clear();
      }
    }
  };

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEY.TOKEN);
    if (token) fetchBooking();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-gradient-to-b from-purple-50 to-white flex flex-col rounded-lg">
      <div className="px-6 py-8 text-center">
        <h1 className="text-2xl font-bold text-gray-900">{t("reservation_search")}</h1>
      </div>

      <div className="flex flex-col gap-10 px-4">
        <div className="rounded-2xl bg-white p-6 shadow-lg">
          <div>
            <label className="mb-2 block text-sm font-semibold text-gray-700">{t("name")}</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t("name")}
              className="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm
                placeholder-gray-400
                focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none"
            />
          </div>
          <p className="mt-2 mb-5 text-xs text-gray-500 leading-relaxed">{t("same_name")}</p>

          <div>
            <label className="mb-2 block text-sm font-semibold text-gray-700">{t("reservation_no")}</label>
            <input
              type="text"
              value={reservationNo}
              onChange={(e) => setReservationNo(e.target.value)}
              placeholder="ex) 12345678"
              className="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm
                placeholder-gray-400
                focus:border-blue-500 focus:ring-2 focus:ring-blue-100 focus:outline-none"
            />
          </div>
        </div>
        <Button onClick={handleSearch} disabled={isDisabled}>
          {t("search")}
        </Button>
      </div>
    </div>
  );
};

export default BookingPage;
